/**
 * Utility functions for handling HTTP status codes
 */

const STATUS_TEXT_MAP = {
  0: 'Success',
  200: 'Success',
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  500: 'Server Error',
}

const STATUS_CLASS_MAP = {
  0: 'status-success',
  200: 'status-success',
  400: 'status-warning',
  401: 'status-warning',
  403: 'status-warning',
  404: 'status-warning',
  500: 'status-error',
}

/**
 * Get human-readable status text for a status code
 * @param {string} statusCode - The HTTP status code
 * @returns {string} Human-readable status text
 */
export function getStatusText(statusCode) {
  return STATUS_TEXT_MAP[statusCode] || `Status ${statusCode}`
}

/**
 * Get CSS class for a status code
 * @param {string} statusCode - The HTTP status code
 * @returns {string} CSS class name
 */
export function getStatusClass(statusCode) {
  return STATUS_CLASS_MAP[statusCode] || 'status-unknown'
}
